import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';

// Boton de exportar a CSV para los listados de DataGrid -- reusa el export
// nativo de la libreria (gratis en la edicion Community) en vez de armar
// algo propio. utf8WithBom evita que Excel rompa los acentos/ñ del CSV
// (todo el contenido de esta app esta en español). Se apaga el boton de
// "Imprimir" que GridToolbarExport trae por defecto porque no se pidio y
// no vale la pena la superficie de UI de mas.
export default function ExportToolbar() {
  return (
    <GridToolbarContainer sx={{ justifyContent: 'flex-end', p: 1 }}>
      <GridToolbarExport
        csvOptions={{ utf8WithBom: true }}
        printOptions={{ disableToolbarButton: true }}
      />
    </GridToolbarContainer>
  );
}
